import { Injectable, Signal, signal } from '@angular/core';

import { Organization } from './organizations.abstraction';

@Injectable({
  providedIn: 'root',
})
export class OrganizationStorageService {
  private readonly _organization = signal<Organization | null>(null);

  get organization(): Signal<Organization | null> {
    return this._organization.asReadonly();
  }

  setOrganization(organization: Organization | null): void {
    this._organization.set(organization);
  }
}
